import Router from 'vue-router'
import comum from './routes/comum'

const index = new Router({
    routes: [
        ...comum
    ]
})

export default index
